"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTable = void 0;
var react_1 = __importDefault(require("react"));
var DataTableRow_1 = require("./DataTableRow");
var DataTableHeader_1 = require("./DataTableHeader");
/**
 * A component that can show lists of objects as a table, supporting sort by column, row selection,
 * etc.
 *
 */
var DataTable = /** @class */ (function (_super) {
    __extends(DataTable, _super);
    function DataTable(props) {
        var _this = _super.call(this, props) || this;
        // Run some validations
        if (_this.props.columnWidths) {
            if (_this.props.columnWidths.length !== _this.props.columnTitles.length) {
                throw new Error("Column sizes must be the same length as headers");
            }
            if (_this.props.columnWidths.reduce(function (acc, val) { return acc + val; }) !== 100) {
                throw new Error("Column sizes must add up to 100");
            }
        }
        return _this;
    }
    DataTable.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: "bg-white py-4 px-8" },
            react_1.default.createElement("table", { className: "w-full text-left" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null, this.props.columnTitles.map(function (h, i) {
                        var width = _this.props.columnWidths
                            ? _this.props.columnWidths[i]
                            : undefined;
                        return (react_1.default.createElement(DataTableHeader_1.DataTableHeader, { key: i, width: width }, h));
                    }))),
                react_1.default.createElement("tbody", null, this.props.elements.map(function (el, i) { return (react_1.default.createElement(DataTableRow_1.DataTableRow, { key: i, parity: i % 2 ? "even" : "odd", formatFunction: _this.props.rowFunction, onClick: _this.props.onRowClick
                        ? function (e) { return _this.props.onRowClick(el, i, e); }
                        : undefined, element: el })); })))));
    };
    return DataTable;
}(react_1.default.Component));
exports.DataTable = DataTable;
